// https://en.wikipedia.org/wiki/Abstract_syntax_tree

import { TextSelectionKind } from './text.model';

export enum TextViewNodeKind {
  WordSequence,
  Line,
  EmptyWord,
  Proxy,
  Selection,
}

export interface TextViewNode {
  kind: TextViewNodeKind;
  content: string;
  ignoreLineBreak?: boolean;
  selection?: TextSelectionKind;

  children?: Array<TextViewNode>;
  next?: TextViewNode;
  previous?: TextViewNode;
  depth?: number;
}
